module.exports = __webpack_public_path__ + "MarkerDefaultSelected.560bc6346defe1d4467d5282c157d9ed.png";